const jaipurLocalities = [
    "Mansarovar",
    "Jagatpura",
    "Vaishali Nagar",
    "Malviya Nagar",
    "Pratap Nagar",
    "Vidhyadhar Nagar",
    "Jhotwara",
    "Bani Park",
    "Tilawala",
    "Murlipura",
    "Raja Park",
    "Bapu Nagar",
    "Jawahar Nagar",
    "Chitrakoot",
    "Narayan Vihar",
    "Tonk Phatak",
    "Sanganer",
    "Sodala",
    "Shyam Nagar",
    "Durgapura",
    "Gopalpura",
    "Adarsh Nagar",
    "Kumbha Marg",
    "Murlipura Scheme",
    "Agarwal Farm",
    "Gurjar Ki Thadi",
    "Ajmer Road",
    "Civil Lines",
    "Sector 29",
    "Tilak Nagar",
    "Sushant City 1",
    "Shipra Path",
    "Lalarpura",
    "Lalkothi",
    "Sethi Colony",
    "Dadi Ka Phatak",
    "Khatipura",
    "Siddharth Nagar",
    "Janta Colony",
    "Bagru",
    "Shastri Nagar",
    "Moti Nagar",
    "A.K. Gopalan Nagar",
    "Indira Gandhi Nagar",
    "Govindpura Kardhani Scheme",
    "Nangal Jaisabohra",
    "Bajaj Nagar",
    "Hasanpura",
    "Sitapura",
    "Bais Godam",
    "Hanuman Nagar",
    "Bhankrota",
    "Mansarovar Extension",
    "Kiran Path",
    "Ashok Nagar",
    "Sheopur",
    "Panchyawala",
    "Vigyan Nagar",
    "Paldi Meena",
    "Govindpura",
    "Prem Nagar",
    "Gandhi Nagar",
    "Brahmpuri",
    "Jaipur Nagar Nigam",
    "Goner",
    "Giriraj Nagar",
    "Mahapura",
    "Vatika",
    "Meera Marg",
    "Ward 27",
    "Rambagh",
    "Vidhyut Nagar",
    "Sector 8",
    "Gokulpura",
    "Rani Sati Nagar",
    "Sikar District",
    "Sindhi Camp",
    "Ganpati Nagar",
    "Milap Nagar",
    "Mahatma Gandhi Nagar",
    "SFS Manasarovar",
    "Transport Nagar",
    "Sindhi Colony",
    "Panch Batti",
    "Housing Board",
    "Jaisinghpura",
    "Nehru Nagar",
    "Nadi Ka Phatak",
    "Pawan Vihar Colony",
    "Kotputli",
    "Vidhan Sabha Nagar",
    "Theekariya",
    "Kanakpura",
    "Tonk Road",
    "Bagru Khurd",
    "Katewa Nagar",
    "Sumer Nagar Extension",
    "Acharya Vinoba Bhave Nagar",
    "Brijlalpura",
    "Dahar Ka Balaji",
    "Karolan Ka Barh",
    "Amer",
    "Malviya Nagar",
    "Sector 26",
    "D-Block",
    "Shankar Vihar",
    "Patrakar Colony",
    "Kalwar Road",
    "Sector 7",
    "Sector-8",
    "Engineers Colony",
    "Shree Niwas Nagar",
    "Mundiya Ramsar",
    "C-Scheme",
    "Dholai",
    "Ekta Nagar",
    "Ganatpura",
    "Vardhman Nagar B",
    "Shivpuri Colony",
    "Arjun Nagar",
    "Malhotra Nagar",
    "Vidhyadhar Nagar",
    "Sector 23",
    "C Scheme",
    "Kankha Ki Dhani",
    "Ramnagariya",
    "Niwaru",
    "Maniyawas",
    "Subhash Nagar",
    "Adarsh Colony",
    "Sector 28",
    "Sushilpura",
    "Tagore Nagar",
    "Gandhi Path West",
    "Maruti Nagar",
    "Karni Vihar",
    "Mahavir Nagar",
    "Taru Chhaya Nagar",
    "Hathod",
    "Partap Nagar",
    "Kamala Nehru Nagar",
    "Ganesh Nagar Vistar",
    "Durga Vihar-D",
    "Gujar Ki Thadi",
    "Sunder Nagar",
    "Mahesh Nagar Phatak",
    "Ram Nagar",
    "Tiwari Ji Ka Bagh",
    "Sirsi",
    "Budhsinghpura",
    "RFC Colony",
    "Goverdhan Colony",
    "Ganatpura",
    "Akhil Nagar",
    "Ganga Sagar-B",
    "Shubham Vihar",
    "Rajat Path",
    "Kalwara",
    "Jagannath Puri",
    "Ward No 18",
    "Kedar Nagar",
    "Tirupati Balaji Nagar",
    "Gurunanak Pura",
    "Chitragupta Nagar-II",
    "Ayodhya Nagar",
    "Dhawas",
    "Sachivalaya Colony",
    "Bank Colony",
    "Shivaji Nagar",
    "Vikas Nagar",
    "Bhawani Nagar",
    "Indraprastha Colony",
    "Angira Nagar",
    "Kumawat Colony",
    "Gomti Colony",
    "Shiv Officers Colony",
    "Shivpuri Colony",
    "Suraj Nagar",
    "Shalimar Bagh Colony",
    "Champapura",
    "Varun Path",
    "Sabrampura",
    "SBBJ Officers Colony",
    "Gopalbari",
    "Amrit Nagar",
    "Hari Nagar",
    "Ekta Nagar",
    "Maa Karni Nagar",
    "Shri Ramnagar Colony",
    "Chankya Puri Colony",
    "Monika Vihar",
    "Vishnupuri",
    "Khushi Vihar",
    "Rail Nagar",
    "Ganga Vihar Colony",
    "Hida Ki Mori",
    "Sanjay Nagar",
    "Banshipuri",
    "Malviya Nagar",
    "Rodu Ram Nagar",
    "Awadhpuri Colony",
    "Shiv Nagar II",
    "Sector 10",
    "Dahmi Kalan",
    "Anand Lok",
    "Guru Jhambeshwar Nagar A",
    "Jamna Puri",
    "Mahadev Nagar",
    "Ekta Nagar",
    "Mansarovar Sector 7",
    "Arpit Nagar",
    "Mata Colony",
    "Khushi Enclave B Block",
    "Omaxe City",
    "Girdharipura",
    "Green Nagar",
    "Patarkar Colony",
    "Mansarovar Sector 9",
    "Block C",
    "Ghati Karolan",
] 

export default jaipurLocalities;
  